// extracted by mini-css-extract-plugin
export var aboveInput = "_lm-0";
export var actionButton = "_lm-5";
export var actionButtonContainer = "_lm-1";
export var actionIcon = "_lm-6";
export var aiInfoContainer = "_lm-2";
export var attachmentWrapper = "_lm-7";
export var bold = "_lm-3";
export var checkIcon = "_lm-8";
export var clickingRecipientBar = "_lm-11";
export var commentThreadSwitch = "_lm-a";
export var draftImage = "_lm-b";
export var draftImageContainer = "_lm-c";
export var draftImages = "_lm-e";
export var editButton = "_lm-g";
export var editor = "_lm-f";
export var editorContainer = "_lm-y";
export var editorErrorTooltipWrapper = "_lm-9";
export var headerDivider = "_lm-h";
export var icon = "_lm-i";
export var info = "_lm-j";
export var internal = "_lm-n";
export var internalDivider = "_lm-k";
export var internalMessage = "_lm-l";
export var messageInputCard = "_lm-m";
export var messageInputForm = "_lm-o";
export var messageInputFormInternal = "_lm-p";
export var options = "_lm-q";
export var publicMessageCustomer = "_lm-s";
export var publicMessageMerchant = "_lm-r";
export var removeImageButton = "_lm-d";
export var replyButtons = "_lm-t";
export var showSignatureButton = "_lm-u";
export var spinner = "_lm-v";
export var verticalButtonDivider = "_lm-4";
export var visibilitySelector = "_lm-w";
export var warning = "_lm-x";
export var wrappingText = "_lm-z";
export var writingInternalNoteTopBorder = "_lm-10";